import { GatsbyBrowser } from 'gatsby';
import { datadogRum } from '@datadog/browser-rum';
import DD_OPTIONS from '@ecs/tng-common/src/scripts/data-dog-options';
import { setWindowElements } from '@ecs/tng-common/src/scripts/helpers';
import { scheduleGatsbyHydrationCompleteFallback } from '@ecs/tng-common/src/scripts/return-user';

export const onRouteUpdate: GatsbyBrowser['onRouteUpdate'] = ({ location, prevLocation }) => {
  if (!prevLocation && !location.hash) {
    // do not restore scroll position on page refresh without hash
    setTimeout(() => window.scrollTo({ top: 0, left: 0, behavior: 'instant' }), 0);
  }
  setTimeout(() => {
    if (prevLocation && location && location !== prevLocation) {
      setWindowElements();
      if (window.instantiatePage) {
        window.instantiatePage();
      }
    }
  }, 20);
};

export const onInitialClientRender = () => {
  // Fallback only. Pages with useReturnUser/useAlerts dispatch from return-user.ts
  // after repo-side return-user/alerts assessment and loading=false.
  scheduleGatsbyHydrationCompleteFallback();
  // run dataDog script
  if (process.env.GATSBY_ENV !== 'development' && datadogRum) {
    datadogRum.init(DD_OPTIONS);
    datadogRum.startSessionReplayRecording();
  }
};

export const shouldUpdateScroll: GatsbyBrowser['shouldUpdateScroll'] = ({
  routerProps: { location }
}) => {
  window.history.scrollRestoration = 'manual';

  setTimeout(() => {
    if (location.hash) {
      // If hash (`/#something`), smooth scroll to that position
      const item = document.querySelector(`${location.hash}`);
      item?.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.scrollTo(0, 0);
    }
  }, 0);

  // do not let gatsby do anything more
  return false;
};